/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Heading_Rift_CollapsedInputs */



/**
* | output |
* | --- |
* | "The Rift collapsed" |
*
* @param {Error_Heading_Rift_CollapsedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_heading_rift_collapsed = /** @type {((inputs?: Error_Heading_Rift_CollapsedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Heading_Rift_CollapsedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Rift ist eingestürzt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La Faille s'est effondrée")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("裂隙坍塌了")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("裂隙崩塌了")
	if (locale === "ko") return /** @type {LocalizedString} */ ("균열이 무너졌습니다")
	return /** @type {LocalizedString} */ ("The Rift collapsed")
});